"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CoreInput = require("../../utilities/CoreInput");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TextInput = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    name,
    value,
    rows = 1,
    collapse = false,
    className,
    type = 'text',
    placeholder,
    onChange,
    onBlur,
    readOnly,
    disabled,
    size,
    maxLength,
    min,
    max,
    multiple,
    pattern,
    step,
    autoComplete,
    list,
    autoFocus,
    tabIndex
  } = _ref;
  const rowsToUse = rows > 1 && collapse ? 1 : rows;
  const [internalValue, setInternalValue] = (0, _react.useState)(value || '');
  const onChangeInternal = e => {
    const {
      target
    } = e;
    const {
      value: val
    } = target;
    setInternalValue(val);
    onChange(val);
  };
  const onBlurInternal = e => {
    const {
      target
    } = e;
    const {
      value: val
    } = target;
    setInternalValue(val);
    onBlur(val);
  };
  const classNames = (0, _classnames.default)({
    textarea: rows > 1
  });
  if (rows > 1) {
    return /*#__PURE__*/_react.default.createElement("textarea", {
      name: name,
      rows: rowsToUse,
      ref: ref,
      className: (0, _classnames.default)('input', className, classNames) || undefined,
      placeholder: placeholder,
      readOnly: readOnly,
      disabled: disabled,
      size: size,
      maxLength: maxLength,
      min: min,
      max: max,
      multiple: multiple,
      pattern: pattern,
      step: step,
      autoComplete: autoComplete ? 'on' : 'off',
      list: list,
      autoFocus: autoFocus,
      value: internalValue,
      onChange: onChangeInternal,
      onBlur: onBlurInternal,
      tabIndex: tabIndex
    });
  }
  return /*#__PURE__*/_react.default.createElement("input", {
    ref: ref,
    type: type,
    name: name,
    className: (0, _classnames.default)('input', className, classNames) || undefined,
    placeholder: placeholder,
    readOnly: readOnly,
    disabled: disabled,
    size: size,
    maxLength: maxLength,
    min: min,
    max: max,
    multiple: multiple,
    pattern: pattern,
    step: step,
    autoComplete: autoComplete,
    list: list,
    autoFocus: autoFocus,
    value: internalValue,
    onChange: onChangeInternal,
    onBlur: onBlurInternal,
    tabIndex: tabIndex
  });
});
TextInput.displayName = 'TextInput';
TextInput.propTypes = {
  name: _propTypes.default.string,
  showLabel: _propTypes.default.bool,
  label: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  className: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  type: _propTypes.default.string,
  rows: _propTypes.default.number,
  collapse: _propTypes.default.bool,
  value: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  size: _propTypes.default.number,
  maxLength: _propTypes.default.number,
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  multiple: _propTypes.default.bool,
  pattern: _propTypes.default.string,
  step: _propTypes.default.number,
  autoComplete: _propTypes.default.bool,
  list: _propTypes.default.string,
  autoFocus: _propTypes.default.bool,
  tabIndex: _propTypes.default.number
};
var _default = exports.default = (0, _CoreInput.withFieldControl)(TextInput, {
  validationIcon: true,
  validationColoring: true
});
//# sourceMappingURL=TextInput.js.map